import { render } from "./DatasetCopyModal.vue?vue&type=template&id=6b04b787&scoped=true"
import script from "./DatasetCopyModal.vue?vue&type=script&lang=js"
export * from "./DatasetCopyModal.vue?vue&type=script&lang=js"

import "./DatasetCopyModal.vue?vue&type=style&index=0&id=6b04b787&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b04b787"]])

export default __exports__